<template>
    <div class="bg-white">
        <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">

            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <div class="faded border-gray-200 border p-5 rounded-lg font-medium text-base text-justify space-y-4">

                    <span v-for="message in messages" v-html="message" />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixins from '../mixins';

    export default {
        mixins: [Mixins],

        props: {
            data: Object,
            messages: Array
        }
    }
</script>
